import { Button } from '@cian/ui-kit/button';
import { HeartStroke16 } from '@cian/ui-kit/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { IAppState } from '../../../common/state';
import { SaveSearchModalContainer } from '../../../filters/containers/SaveSearchModalContainer';
import { IJsonQuery } from '../../../json_query';
import { getTrackingData } from '../../../selectors/getTrackingData';
import { TOnSubscribedExtendedParameters } from '../../../types/savedSearch';
import { isSuburban, offerTypeFromJsonQuery } from '../../../utils/category';
import {
  trackShowSaveSearchClick,
  trackSuburbanCloseSaveSearchClick,
  trackSuburbanShowSaveSearchClick,
  trackSaveSearchSubscribed,
  trackSuburbanSaveSearchSubscribed,
} from '../tracking';

export const SaveSearchButtonContainer = () => {
  const [opened, setOpened] = React.useState(false);
  const jsonQuery = useSelector<IAppState, IJsonQuery>(state => state.filters.jsonQuery);
  const isSuburbanSearch = isSuburban(offerTypeFromJsonQuery(jsonQuery));
  const { page } = useSelector(getTrackingData);

  const handleSubscribed = React.useCallback(
    (parameters: TOnSubscribedExtendedParameters) => {
      const { defaultEmail, defaultTitle, subscribeToPushAvailable, ...commonParameters } = parameters;

      if (isSuburbanSearch) {
        trackSuburbanSaveSearchSubscribed({
          ...commonParameters,
          defaultTitle,
          defaultEmail,
          jsonQuery,
          page,
        });
      }

      trackSaveSearchSubscribed({
        ...commonParameters,
        jsonQuery,
        subscribeToPushAvailable,
      });
    },
    [isSuburbanSearch, jsonQuery, page],
  );

  const openModal = React.useCallback(() => {
    trackShowSaveSearchClick();

    if (isSuburbanSearch) {
      trackSuburbanShowSaveSearchClick(jsonQuery);
    }

    setOpened(true);
  }, [isSuburbanSearch, jsonQuery]);

  const closeModal = React.useCallback(() => {
    if (isSuburbanSearch) {
      trackSuburbanCloseSaveSearchClick(jsonQuery);
    }

    setOpened(false);
  }, [isSuburbanSearch, jsonQuery]);

  return (
    <>
      <Button
        theme="fill_white_primary"
        size="XS"
        beforeIcon={<HeartStroke16 color="primary_100" />}
        onClick={openModal}
      >
        Сохранить поиск
      </Button>

      <SaveSearchModalContainer open={opened} onClose={closeModal} onSubscribed={handleSubscribed} />
    </>
  );
};
